import Modal from "../Modal";
import DeliveryAddressEditForm from "../../forms/deliveryAddress/DeliveryAddressEditForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function DeliveryAddressEditModal({show, handleClose, company_id, address, callback, title = null}) {
    const { t } = useTranslation();
    const defaultTitle = t("deliveryAddress.edit");
    return (
        <Modal title={title || defaultTitle} show={show} handleClose={handleClose}>
            <DeliveryAddressEditForm handleClose={handleClose} address={address} company_id={company_id} callback={callback} />
        </Modal>
    );
};